export var Alignments;
(function (Alignments) {
    Alignments["start"] = "flex-start";
    Alignments["center"] = "center";
    Alignments["end"] = "flex-end";
    Alignments["stretch"] = "stretch";
    Alignments["between"] = "space-between";
    Alignments["around"] = "space-around";
})(Alignments || (Alignments = {}));
//# sourceMappingURL=Alignments.js.map